module.exports = __webpack_public_path__ + "static/media/png.d41885b1.svg";